import React, { useState, useRef, useEffect } from 'react';
import './Collapse.scss'; // CSS file

export default function Collapse({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const [isDesktop, setIsDesktop] = useState(false);
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState('0px');

  // Track screen width
  useEffect(() => {
    const checkWidth = () => setIsDesktop(window.innerWidth >= 768);
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  // Collapse behavior
  useEffect(() => {
    if (contentRef.current && isDesktop) {
      setMaxHeight(open ? `${contentRef.current.scrollHeight}px` : '0px');
    }
  }, [open, children, isDesktop]);

  return (
    <>
      <div className="collapse-container">
        <button
          aria-expanded={open}
          className="collapse-toggle"
          disabled={defaultOpen && !isDesktop}
          onClick={() => setOpen(!open)}
        >
          {title}
        </button>

        {isDesktop ? (
          <div ref={contentRef} className="collapse-content" style={{ maxHeight }}>
            <div className="collapse-inner">{children}</div>
          </div>
        ) : (
          <div
            ref={contentRef}
            className={`collapse-content ${open ? 'is-open' : ''}`}
            data-show={!!defaultOpen}
          >
            {!defaultOpen && (
              <h5 className="collapse-header">
                {title}
                <button onClick={() => setOpen(!open)}>X</button>
              </h5>
            )}
            <div className="collapse-inner">{children}</div>
          </div>
        )}
      </div>
    </>
  );
}
